import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * A mixin that brings the possibility to temporarily disable CSS transitions using
 * {@link module:ui/view~View} methods. It is helpful when, for instance, the transitions should not happen
 * when the view is first displayed but they should work normal in other cases.
 *
 * The methods to control the CSS transitions are:
 * * `disableCssTransitions()` – Adds the `.ck-transitions-disabled` class to the
 * {@link module:ui/view~View#element view element}.
 * * `enableCssTransitions()` – Removes the `.ck-transitions-disabled` class from the
 * {@link module:ui/view~View#element view element}.
 *
 * The usage comes down to:
 *
 * ```ts
 * const MyViewWithCssTransitionDisabler = CssTransitionDisablerMixin( MyView );
 * const view = new MyViewWithCssTransitionDisabler();
 *
 * // ...
 *
 * view.disableCssTransitions();
 * view.show();
 * view.enableCssTransitions();
 * ```
 *
 * @param view View instance that should get this functionality.
 */
export default function CssTransitionDisablerMixin(view) {
  var Mixin = /*#__PURE__*/function (_view) {
    _inherits(Mixin, _view);
    var _super = _createSuper(Mixin);
    function Mixin() {
      var _this;
      _classCallCheck(this, Mixin);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.set('_isCssTransitionsDisabled', false);
      _this.initializeCssTransitionDisablerMixin();
      return _this;
    }
    _createClass(Mixin, [{
      key: "disableCssTransitions",
      value: function disableCssTransitions() {
        this._isCssTransitionsDisabled = true;
      }
    }, {
      key: "enableCssTransitions",
      value: function enableCssTransitions() {
        this._isCssTransitionsDisabled = false;
      }
    }, {
      key: "initializeCssTransitionDisablerMixin",
      value: function initializeCssTransitionDisablerMixin() {
        this.extendTemplate({
          attributes: {
            class: [this.bindTemplate.if('_isCssTransitionsDisabled', 'ck-transitions-disabled')]
          }
        });
      }
    }]);
    return Mixin;
  }(view);
  return Mixin;
}